import { render } from "./CPOReservations.vue?vue&type=template&id=969d7fa2"
import script from "./CPOReservations.vue?vue&type=script&lang=js"
export * from "./CPOReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__